import * as React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Title from "./Title";
import { Card, CardContent, Grid } from "@mui/material";
import { addZeroes } from "./utils";

export default function DollarCard({ data, title }) {


  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
          <Grid item>
            <React.Fragment>
              <Typography
                component="h2"
                variant="h6"
                color="primary"
                gutterBottom
                marginLeft={1}
              >
                {title}
              </Typography>
              <Typography component="p" variant="h4" marginLeft={2}>
                {data ? `$${addZeroes(data)}` : `$${Number(0).toLocaleString()}`}
              </Typography>
            </React.Fragment>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
